import { RootState } from "../store";
import { IUserState } from "./types";

export const userSelector = (state: RootState): IUserState => state.user;

export const partnerIdSelector = (state: RootState): string | number | null => state.user.partnerId;

export const userDataSelector = (state: RootState) => state.user.user;

